"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddVehicleByVinResponseSchema = exports.AddVehicleByModelYearResponseSchema = void 0;
var _dateFns = require("date-fns");
var _zod = require("zod");
const AddVehicleByVinResponseSchema = exports.AddVehicleByVinResponseSchema = _zod.z.object({
  data: _zod.z.array(_zod.z.object({
    brand: _zod.z.enum(["L", "T"]),
    make: _zod.z.enum(["LEXUS", "TOYOTA"]),
    model: _zod.z.string(),
    modelYear: _zod.z.string().refine(function (x) {
      return (0, _dateFns.isValid)(new Date(x));
    }),
    vehicleId: _zod.z.string(),
    vin: _zod.z.string(),
    yearMakeModel: _zod.z.string()
  }).refine(function (data) {
    return data.vehicleId === data.vin;
  }, "VehicleId must match VIN.")).length(1)
}).transform(function (_ref) {
  let {
    data
  } = _ref;
  return data;
});
const AddVehicleByModelYearResponseSchema = exports.AddVehicleByModelYearResponseSchema = _zod.z.object({
  data: _zod.z.array(_zod.z.object({
    brand: _zod.z.enum(["L", "T"]),
    make: _zod.z.enum(["LEXUS", "TOYOTA"]),
    model: _zod.z.string(),
    modelYear: _zod.z.string().refine(function (x) {
      return (0, _dateFns.isValid)(new Date(x));
    }),
    vehicleId: _zod.z.string(),
    yearMakeModel: _zod.z.string()
  })).length(1)
}).transform(function (_ref2) {
  let {
    data
  } = _ref2;
  return data;
});